import { useTranslation } from "@coworker/locales";
import { ApplyFilter } from "@coworker/apprestructured/src/shared/filters/types/apply";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { Article, Combined } from "../types/article";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";

const ONGOING_ID = "ongoing";

function useTasksSelectFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: ONGOING_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: ONGOING_ID,
      title: t("ongoingTasksString"),
      options: [
        { value: "ongoingTasks", title: t("articlesWithOngoingTasksString") },
        {
          value: "noOngoingTasks",
          title: t("articlesWithNoOngoingTasksString"),
        },
      ],
      enabled: true,
      defaultValue,
    },
    t("allArticlesString")
  );
}

function useTasksSelectArticleFilter() {
  const filter: ApplyFilter<SelectFilter, Article> = {
    filter: useTasksSelectFilter(),
    filterCompare: (item: Combined<Article>, { value }: FilterValue) => {
      switch (value) {
        case "ongoingTasks":
          return item.tasks && item.tasks.length ? true : false;
        case "noOngoingTasks":
          return item.tasks && item.tasks.length ? false : true;
        default:
          return true;
      }
    },
  };

  return filter;
}

export { useTasksSelectArticleFilter };
